import {useContext} from 'react'
import {get} from 'lodash'
import {AuthContext} from '../context/AuthProvider'

export default function useAuth() {
  const {auth, authNonce, setUser, loginUser, refreshAuth, logoutUser} = useContext(AuthContext)
  const isLoading = auth === 'pending'
  const entityId = get(auth, 'attributes.entityId')
  return {auth, authNonce, entityId, isLoading, refreshAuth, setUser, loginUser, logoutUser}
}
